import PropTypes from "prop-types"
import React, { useState } from "react"

import StripeAccountCreation from "./StripeAccountCreation"
import StripeConnectAccountManagement from "./StripeConnectAccountManagement"
import StripeConnectOnboarding from "./StripeConnectOnboarding"

const StripeConnectContainer = ({
  stripeManagedAccountId: initialStripeAccountId,
  smaCountries,
  onSuccess,
  onUpdate,
  onAccountCreated,
  mode = "onboarding", // "onboarding" or "management"
  onboardingRequiredFieldsComplete = false,
  stripeConnectInstance,
}) => {
  const [stripeAccountId, setStripeAccountId] = useState(initialStripeAccountId)

  const handleAccountCreated = (accountId) => {
    setStripeAccountId(accountId)
    if (onAccountCreated) {
      onAccountCreated(accountId)
    }
  }

  // If we have an account ID and we're in management mode, show account management
  if (onboardingRequiredFieldsComplete && mode === "management") {
    return (
      <StripeConnectAccountManagement
        stripeConnectInstance={stripeConnectInstance}
        onUpdate={onUpdate}
      />
    )
  }

  // If we have an account ID and we're in onboarding mode (or default), show onboarding
  if (stripeAccountId) {
    return (
      <StripeConnectOnboarding
        onSuccess={onSuccess}
        stripeConnectInstance={stripeConnectInstance}
      />
    )
  }

  // If no account ID, show account creation (only relevant for onboarding flow)
  return (
    <StripeAccountCreation
      smaCountries={smaCountries}
      onAccountCreated={handleAccountCreated}
    />
  )
}

StripeConnectContainer.propTypes = {
  stripeManagedAccountId: PropTypes.string,
  smaCountries: PropTypes.arrayOf(
    PropTypes.shape({
      countryCode: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    })
  ).isRequired,
  onSuccess: PropTypes.func,
  onUpdate: PropTypes.func,
  onAccountCreated: PropTypes.func,
  mode: PropTypes.oneOf(["onboarding", "management"]),
  onboardingRequiredFieldsComplete: PropTypes.bool,
  stripeConnectInstance: PropTypes.object,
}

export default StripeConnectContainer
